export default __webpack_public_path__ + "static/media/lista.68d13c3c.svg";